<template>
  <div class="orders" :class="revisionLits.length > 2 ? '' : 'ht'">
    <!-- 头部 -->
    <hearderCommon :text="textT"></hearderCommon>
    <!-- 选择配送地址 -->
    <div class="dispatch">
      <van-cell is-link @click="showPopup">
        <div>
          <van-row gutter="20" class="orders-van-row" style="padding:0;padding-bottom:5px">
            <van-col span="8" class="orders-van-col">配送地址</van-col>
          </van-row>
          <van-row gutter="20" class="orders-van-row" style="padding:0">
            <van-col
              span="24"
              class="orders-van-col chose"
              v-show="showPrice"
            >{{orList.deliveryName}}</van-col>
            <van-col span="24" class="orders-van-col chose" v-show="!showPrice">{{place}}</van-col>
          </van-row>
        </div>
        <!-- <div class="dispatch-price chose" v-show="!showPrice">{{place}}</div> -->
      </van-cell>
      <!-- 选择地址 -->
      <van-popup v-model="showPp" position="bottom" :style="{ height: '30%' }">
        <van-picker
          show-toolbar
          ref="picker"
          :columns="columns"
          @cancel="onCancel"
          @confirm="onConfirm"
          :default-index="0"
          @change="choseDId"
        />
      </van-popup>

      <div class="orders-time">
        <van-row gutter="20" class="orders-van-row oddr">
          <van-col span="8" class="orders-van-col">配送日期</van-col>
        </van-row>
        <van-cell is-link @click="showDataTime" v-show="!showTime" class="lateDay">{{lateDay}}</van-cell>
        <van-row gutter="20" class="orders-van-row clss" v-show="showTime"  style="padding-bottom:0 !important">
          <van-col span="24" @click="others" class="DlateDay">{{ orList.deliveryTime | dateFil}}</van-col>
        </van-row>
      </div>

        <!-- 订单类型 -->
      <van-cell is-link @click="propOrderClick" :disabled="deliveryId" >
        <div>
          <van-row
            gutter="20"
            class="orders-van-row"
            style="
              padding: 0;
              padding-bottom: 5px;
              border-top: 1px dashed #f7f7f7;
              padding-top: 5px;
            "
          >
            <van-col span="8" class="orders-van-col">订单类型</van-col>
          </van-row>
          <van-row
            gutter="20"
            class="orders-van-row"
            style="padding: 0"
            v-show="showOrderType"
          >
            <van-col span="8" class="orders-van-col chose">请选择</van-col>
          </van-row>
        </div>
        <div class="dispatch-price chose" v-show="!showOrderType">
          {{ customerOrderType }}
        </div>
      </van-cell>
      <van-popup
        v-model="showPropOrder"
        position="bottom"
        :style="{ height: '30%' }"
      >
        <van-picker
          ref="showPropOrder"
          show-toolbar
          :columns="orderColumns"
          @cancel="showPropOrder = false"
          @confirm="onOrderConfirm"
          value-key="customerOrderType"
          :default-index="0"
        />
      </van-popup>
    </div>

    <!-- 选择日期 -->
    <van-popup v-model="showData" position="bottom">
      <van-datetime-picker
        class="orders-datatime"
        v-model="currentDate"
        type="date"
        :min-date="minDate"
        :max-date="maxDate"
        :formatter="formatter"
        @confirm="confirm"
      />
    </van-popup>

    <!-- 订单号 -->
    <div class="ordersNum">
      <div class="ty-center">
        <van-row>
          <van-col span="18">订单{{orList.orderCode}}</van-col>
          <van-col span="6">
            <van-row type="flex" justify="end">
              <van-col span="24" style="position: relative;" @click="addNewGoods">
                <van-icon
                  name="balance-list-o"
                  style="position: absolute;top: 10px;left:-15px"
                  color="rgb(116, 180, 43)"
                />
                <span style="color:rgb(116, 180, 43)" @click="addNew">新增商品</span>
              </van-col>
            </van-row>
          </van-col>
        </van-row>
      </div>
    </div>
    <!-- 商品详情 -->
    <div style="position: relative; padding-bottom:60px;" class="reList">
      <van-checkbox-group v-model="result">
        <div class="goodList" v-for="index in revisionLits" :key="index.orderDtlId">
          <van-checkbox
            :name="index.orderDtlId"
            checked-color="#74B42B"
            v-model="index.isChecked"
            @click="ischeck(index)"
          ></van-checkbox>
          <div class="ty-top">
            <img :src="index.picUrl" alt />
            <p class="text1">{{index.goodsName}}</p>
            <br />
            <div class="weight">￥{{index.salePrice/index.saleRatio}}/{{index.saleUnitLabel}}</div>
            <div class="text3">
              <span
                class="ty-left"
              >￥{{index.salePrice}}/{{index.saleUnitLabel}}({{index.saleRatio}}{{index.goodsUnitLabel}})</span>
              <span class="ty-right">
                <van-stepper
                  style="width:75px"
                  class="stepper"
                  button-size="20px"
                  input-width="24px"
                  min="0"
                  async-change
                  @overlimit="removeAllGoods(index)"
                  @minus="removeGoods(index)"
                  @plus="addGoods(index)"
                  @focus="changgeGoods(index)"
                  v-model="index.orderQty"
                />
              </span>
            </div>
            <!-- 备注 -->
            <div class="remark van-ellipsis" @click="showPop(index.orderDtlId)">备注：{{index.remark}}</div>
            <!-- 备注框 -->
            <van-dialog
              v-model="index.showPop"
              confirmButtonColor="rgba(116, 180, 43, 1)"
              @confirm="choRemark(index)"
              @cancel="cancelRemark(index)"
              show-cancel-button
            >
              <van-cell-group>
                <van-field
                  v-model="index.newRemark"
                  rows="1"
                  autosize
                  @input="remarkOd(index)"
                  type="textarea"
                  maxlength="50"
                  placeholder="请输入备注"
                  show-word-limit
                />
              </van-cell-group>
            </van-dialog>
            <!-- 修改商品数量 -->
            <van-dialog
              v-model="index.showDia"
              title="修改商品数量"
              show-cancel-button
              confirmButtonColor="rgba(116, 180, 43, 1)"
              @confirm="changgeGoodsNumDan(index)"
            >
              <input type="text" v-model="index.newOrderQty" class="changeInput" />
            </van-dialog>
          </div>
        </div>
      </van-checkbox-group>
    </div>
    <van-submit-bar
      :price="totalPrice"
      button-text="确认"
      @submit="onSubmit"
      safe-area-inset-bottom
      button-type="info round"
    >
      <van-checkbox v-model="isCheckAll" checked-color="#74B42B" @click="checkAll">全选</van-checkbox>
    </van-submit-bar>
  </div>
</template>

<script>
import hearderCommon from "../common/headerCommon";
export default {
  created() {
    // 获取订单Id
    this.orderId = this.$route.query.orderId;
    // 获取客户Id
    this.customerId = localStorage.getItem("customerId");
    // 获取订单信息
    this.$axios.get(`/trade/tradeOrder/${this.orderId}`).then(res => {
      this.orList = res.data.data;
      this.deliveryId = this.orList.deliveryId;
      this.place = res.data.data.deliveryName;
      this.driverId = res.data.data.driverId;
      this.customerOrderType = res.data.data.customerOrderType
      if (this.customerOrderType) this.showOrderType = false
      this.customerOrderId = res.data.data.customerOrderId
      this.deliveryTime = new Date(res.data.data.deliveryTime);
      // 订单列表
      this.children = [...res.data.data.children];
      this.revisionLits = res.data.data.children;
      this.revisionLits.map(index => {
        this.$set(index, "isSelected", true);
        this.$set(index, "showPop", false);
        this.$set(index, "showDia", false);
        this.$set(index, "newRemark", index.remark);
        this.$set(index, "newOrderQty", index.orderQty);
      });
      this.revisionLits.forEach(item => {
        this.result.push(item.orderDtlId);
      });
      localStorage.setItem("revisionLits", JSON.stringify(this.revisionLits));
    });
    // 获取配送信息
    this.$axios
      .get(`/customer/customerDelivery/customer/${this.customerId}`)
      .then(res => {
        this.priceList = res.data.data;
        res.data.data.forEach(item => {
          this.columns.push(item.name);
        });
      });
  },
  data() {
    return {
      revisionLits: [], //修改订单列表
      orList: {}, // 订单详情
      customerId: "", //用户ID
      showPp: false, //popup框显示
      columns: [], // 选择框列表
      priceList: [], //地址列表
      deliveryId: "", //地址ID
      showPrice: true, //显示已选地址
      place: "", //已选地址
      deliveryTime: "", //后台传输时间
      lateDay: "", //前端展示时间
      showTime: true, //显示时间
      currentDate: new Date(), //选择日期
      showData: false, //下弹出框
      minDate: new Date(), //选择最小时间
      maxDate: new Date(2022, 10, 1), //选择最大时间
      orderId: "", // 订单ID
      isCheckAll: true, // 是否全选
      result: [], //全选,
      showPopups: false, //dialog
      children: [], //
      remarkId: "", //备注id
      remark: "", //备注
      driverId: "", // 配送标签
      textT: "提交订单",
      showOrderType: true, //用来显示订单类型
      showPropOrder: false, //订单类型弹窗
      orderColumns: [], //订单类型数据
      customerOrderType:'', //订单类型名称
      customerOrderId:'' , // 订单类型ID
    };
  },
  watch: {
    deliveryId(val) {
      // 获取订单类型
      this.$axios
        .post("/trade/tradeCustomerOrderType/list", {
          customerId: this.customerId,
          deliveryId: val,
        })
        .then((res) => {
          if (res.data) {
            this.orderColumns = res.data.data
          }
        })
        .catch(() => {});
    },
  },
  methods: {
    // 提交订单
    onSubmit() {
      let fc = this.children.every(item => item.orderQty == 0);
      if (!this.place || !this.deliveryTime) {
        this.$toast("配送地址或配送时间不能为空");
      } else if (fc) {
        this.$toast("所有商品不能都为空");
      } else {
        let fs = this.priceList.find(item => {
          return item.name == this.place;
        });
        this.deliveryId = fs.deliveryId;
        this.$axios
          .post("/trade/tradeOrder/modify", {
            deliveryId: this.deliveryId,
            deliveryTime: this.deliveryTime,
            customerId: this.customerId,
            goodsKindValue: "0",
            children: this.children,
            orderId: this.orderId,
          customerOrderId:this.customerOrderId,
          customerOrderType:this.customerOrderType
          })
          .then(res => {
            if (res.data.code == 0) {
              localStorage.setItem("orderId", res.data.data);
              this.$router.push("/Particular/particularHarvested");
            }
          });
      }
    },
    propOrderClick(){
      if(!this.deliveryId) return false
      this.showPropOrder = true
    },
    onOrderConfirm(){
      this.customerOrderType = this.$refs.showPropOrder.getValues()[0].customerOrderType
      this.customerOrderId = this.$refs.showPropOrder.getValues()[0].customerOrderId
      this.showOrderType =  false
      this.showPropOrder = false
    },
    // 选择配送地址标签
    choseDId() {},
    // 新增商品
    addNewGoods() {},
    // 回退
    orderBack() {
      window.history.back();
    },
    // 配送时间选择
    deliveryTM(day) {
      // 往后台传输的数据
      this.deliveryTime = this.$moment()
        .add(+day, "day")
        .toDate();
      // 前台展示数据
      this.lateDay = this.$moment()
        .add(+day, "day")
        .format("YYYY-MM-DD");
      this.showTime = false;
    },
    // 显示修改数量
    changgeGoods(index) {
      index.newOrderQty = index.orderQty;
      index.showDia = true;
    },
    // 修改数量
    changgeGoodsNumDan(index) {
      index.orderQty = index.newOrderQty;
    },
    // 其他时间
    others() {
      this.showData = true;
    },
    // 选择地址选择
    showPopup() {
      this.showPp = true;
    },
    //点击取消
    onCancel() {
      this.showPp = false;
    },
    // 手动选择时间
    showDataTime() {
      this.showData = true;
    },
    // 修改时间样式
    formatter(type, value) {
      if (type === "year") {
        return `${value}年`;
      } else if (type === "month") {
        return `${value}月`;
      } else if (type === "day") {
        return `${value}日`;
      }
      return value;
    },
    // 点击确认
    onConfirm(value) {
      this.place = value;
      this.showPp = false;
      this.showPrice = false;
    },
    // 时间按确认
    confirm(value) {
      this.deliveryTime = value;
      this.showTime = false;
      this.lateDay = this.$moment(value).format("YYYY-MM-DD");
      this.showData = false;
    },
    // 全选
    checkAll() {
      this.isCheckAll = !this.isCheckAll;
      if (this.isCheckAll) {
        this.children = [...this.revisionLits];
      } else {
        this.children = [];
      }
      this.isCheckAll
        ? this.revisionLits.forEach(item => this.result.push(item.orderDtlId))
        : (this.result = []);
      this.revisionLits.forEach(item => {
        item.isSelected = this.isCheckAll;
      });
    },
    // 单选
    ischeck(index) {
      index.isSelected = !index.isSelected;
      if (index.isSelected) {
        // 选择加入
        this.children.unshift(index);
        this.result.unshift(index.orderDtlId);
      } else {
        // 不选择删除children
        for (var i = 0; i < this.children.length; ) {
          if (index.orderDtlId == this.children[i].orderDtlId) {
            this.children.splice(i, 1);
          } else {
            i++;
          }
        }
      }
      if (this.revisionLits.every(item => item.isSelected == true)) {
        this.revisionLits.forEach(item => this.result.push(item.cartId));
        this.isCheckAll = true;
      } else {
        this.isCheckAll = false;
      }
    },
    // 获取订单总数
    async getCartAll() {
      const res = await this.$axios.get(
        `/trade/tradeCart/count?customerId=${this.customerId}`
      );
      this.sum = res.data.data;
    },
    // 获取订单列表
    getCartList() {
      if (JSON.parse(localStorage.getItem("revisionLits")) === null) {
        this.revisionLits = [];
      } else {
        this.revisionLits = JSON.parse(localStorage.getItem("revisionLits"));
      }
    },
    //添加备注
    choRemark(index) {
      // this.addGood(index);
      index.remark = index.newRemark;
    },
    //取消备注
    cancelRemark() {},
    // 清空购物车
    clearAll() {
      this.$dialog
        .confirm({
          title: "提示",
          message: "你确定要清空购物车吗",
          confirmButtonColor: "#74b42b"
        })
        .then(async () => {
          // on confirm
          this.$axios.delete(
            `/trade/tradeCart/delAll?customerId=${this.customerId}`
          );
          const res = await this.$axios.get(
            `/trade/tradeCart/list?customerId=${this.customerId}`
          );
          this.revisionLits = res.data.data;
          localStorage.setItem(
            "revisionLits",
            JSON.stringify(this.revisionLits)
          );
          this.getCartList();
        })
        .catch(() => {
          // on cancel
        });
    },
    onLoad() {
      // this.loading = false;
    },
    // 备注框
    showPop(id) {
      const rs = this.revisionLits.find(item => {
        return item.orderDtlId == id;
      });
      rs.showPop = true;
      rs.newRemark = rs.remark;
    },
    remarkOd() {},
    // 步进器添加商品
    addGoods(index) {
      if (index.isSelected) {
        let ft = this.children.filter(item => {
          return item.orderDtlId == index.orderDtlId;
        });
        ft.orderQty = index.orderQty;
      }
    },
    // 步进器减少商品
    removeGoods(index) {
      this.addGoods(index);
    },
    // 步进器删除商品
    removeAllGoods() {},
    // 添加新商品
    addNew() {
      this.$router.push({ path: "/classify", query: { categoryId: "1" } });
    }
  },

  computed: {
    // 合计价格
    totalPrice() {
      return this.revisionLits.reduce((price, item) => {
        if (item.isSelected) {
          price += item.orderQty * item.salePrice * 100;
        }
        return price;
      }, 0);
    },
    // 总件数
    orderListLength() {
      return this.revisionLits.length;
    }
  },
  components: {
    hearderCommon
  }
};
</script>

<style scoped>
.orders {
  background: rgba(242, 242, 242, 1);
  padding-top: 40px;
}
.order-header-back {
  width: 80px;
}
.header {
  background: rgba(237, 237, 237, 1);
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  line-height: 40px;
  color: rgba(102, 102, 102, 1);
  position: relative;
  padding-left: 30px;
}
.i {
  position: absolute;
  top: 13px;
  left: 10px;
}
.dispatch {
  margin: 10px auto;
  width: 95%;
  padding-left: 1%;
  background-color: #fff;
  box-shadow: 0px 1px 2px 0px rgba(153, 153, 153, 0.5);
  border-radius: 8px;
}
.van-cell--clickable {
  border-radius: 8px;
}
.van-cell__label {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 20px;
  margin-bottom: 7px;
}
.van-cell__right-icon {
  position: absolute;
  top: 45%;
  right: 7%;
}
.van-cell__title {
  border-bottom: 1px dashed #999;
}
.orders-van-row {
  padding-left: 16px;
  padding-bottom: 10px;
}
.oddr {
  padding-bottom: 3px;
}
.orders-van-col {
  font-size: 12px;
  position: relative;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 17px;
}
.ordersNum {
  padding-left: 3%;
  line-height: 32px;
  background: rgba(237, 237, 237, 1);
  box-shadow: 0px 0px 1px 1px rgba(221, 221, 221, 0.5);
  font-size: 14px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(102, 102, 102, 1);
}

.ty-top {
  width: 85%;
  position: relative;
  background-color: #fff;
  margin-left: 8%;
  margin-top: 2%;
  border-radius: 10px;
  padding: 10px;
  padding-bottom: 6px;
 box-shadow: 0px 0px 4px 1px rgba(153, 153, 153, 0.1);
  font-size: 12px;
  overflow: hidden;
}
.ty-top img {
  border-radius: 8px;
  margin-right: 6px;
}
.changeInput {
  margin: 10px 20%;
}
.sign {
  position: absolute;
  padding-left: 20px;
  box-sizing: border-box;
  right: 0;
  width: 90px;
  height: 24px;
  line-height: 24px;
  background: linear-gradient(
    90deg,
    rgba(116, 180, 43, 0) 0%,
    rgba(116, 180, 43, 0.5) 22%,
    rgba(116, 180, 43, 1) 100%
  );
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  border-radius: 2px;
}
.place1 {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 17px;
}
.place2 {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 20px;
}
.line {
  width: 100%;
  height: 1px;
  background-color: #dddddd;
  margin: 5px 0;
}
.time1 {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 17px;
}
.time2 {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(116, 180, 43, 1);
  line-height: 20px;
}
.ty-center {
  height: 32px;
  line-height: 32px;
  font-size: 14px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(102, 102, 102, 1);
  background: rgba(237, 237, 237, 1);
  padding-left: 5%;
  box-shadow: 0px 0px 1px 1px rgba(221, 221, 221, 0.5);
}
img {
  float: left;
  width: 80px;
  height: 88px;
  background: rgba(247, 247, 247, 1);
  border-radius: 2px;
  object-fit: cover;
}
.text1 {
  display: -webkit-box;
  overflow: hidden;
  white-space: normal !important;
  text-overflow: ellipsis;
  word-wrap: break-word;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  font-size: 14px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(102, 102, 102, 1);
  line-height: 20px;
}
.text2 {
  font-size: 11px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 16px;
}
.weight {
  width: 68px;
  background: rgba(247, 247, 247, 1);
  border-radius: 2px;
  float: left;
  text-align: center;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 21px;
  border-radius: 10%;
}
.ty-left {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(245, 166, 35, 1);
  line-height: 22px;
}
.ty-right {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 20px;
  float: right;
}
.text3 {
  margin: 35px 0 6px;
  padding-left: 80px;
}
.remark {
  margin-top: 50px;
  width: 98%;
  margin: 0 auto;
  background: rgba(102, 102, 102, 0.05);
  border-radius: 8px;
  font-size: 10px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 20px;
  padding-left: 10px;
}
.orderList >>> .van-icon-success {
  border: 1px solid rgba(153, 153, 153, 1);
}
.orderList >>> .goodList .van-icon-success {
  position: absolute;
  left: 1%;
  top: 50%;
}
.van-submit-bar__button {
  margin-left: 3%;
  background: linear-gradient(
    135deg,
    rgba(172, 219, 86, 1) 0%,
    rgba(116, 180, 43, 1) 100%
  );
  border: 0px solid #000;
  border-radius: 50px;
  height: 80%;
  line-height: 80%;
  margin-right: 10px;
}
.orderList >>> .van-icon-success {
  border: 1px solid rgba(153, 153, 153, 1);
}
.orderList >>> .goodList .van-icon-success {
  position: absolute;
  left: 1%;
  top: 50%;
}
.van-submit-bar__button {
  background: linear-gradient(
    135deg,
    rgba(172, 219, 86, 1) 0%,
    rgba(116, 180, 43, 1) 100%
  );
  border: 0px solid #000;
  border-radius: 50px;
  height: 80%;
  line-height: 80%;
  margin-right: 10px;
}
.van-submit-bar {
  background-color: rgba(237, 237, 237, 1);
}
.van-submit-bar__bar {
  padding-left: 3%;
  padding-right: 0 !important;
}
.van-submit-bar__tip {
  padding: 2px 16px;
  background-color: rgba(245, 166, 35, 0.1);
}
.van-submit-bar__price {
  color: rgba(245, 166, 35, 1);
}
.orders-submit-bar {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
}
.orders >>> .van-picker__confirm,
.orders >>> .van-picker__cancel {
  color: #74b42b !important;
}
.chose {
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 20px;
  font-size: 16px;
}
.lateDay >>> .van-cell__value,
.van-cell__value--alone {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(116, 180, 43, 1);
  line-height: 20px;
}
.orders-time >>> .van-cell__right-icon {
  top: 5%;
}
.lateDay {
  padding-top: 3px;
}
.DlateDay {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(116, 180, 43, 1);
  line-height: 20px;
}

.goodList {
  position: relative;
}
.orders >>> .van-icon-success {
  border: 1px solid rgba(153, 153, 153, 1);
}
.orders >>> .goodList .van-icon-success {
  position: absolute;
  left: 1%;
  top: 50%;
}
.reList >>> .van-checkbox {
  height: 0;
}

.stepper {
  border-radius: 20px;
  border: 1px solid rgba(116, 180, 43, 1);
}
.stepper >>> button {
  background-color: #fff;
  border-radius: 50%;
  color: rgba(116, 180, 43, 1);
}
.stepper >>> input {
  background-color: #fff;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 20px;
}
</style>